import React, { useEffect, useState } from "react";
import { listBackupsForType } from "../redux/actions/backupRestoreActions";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, xcss } from "@atlaskit/primitives";
import BackupFlowButton from "./BackupFlowButton";
import FlowSelectList from "../integrations/flow/components/FlowSelectList";
import { Label } from "@atlaskit/form";
import RestoreFlowFromFile from "./RestoreFlowFromFile";
import ListAllFlowsWithBackup from "./ListAllFlowsWithBackup";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import RestoreFlowAPI from "./RestoreFlowAPI";

const BackupPage = () => {
  const [flowId, setFlowId] = useState("");

  const flow = useSelector((state) => state.integration.flow);
  //list of bucket keys in format customerid/flow/flowid/filename.json
  const dispatch = useDispatch();

  useEffect(() => {
    if (flow) {
      dispatch(listBackupsForType("flow", flow.id));
    }
  }, [flow]);
  const boxStyle = xcss({
    marginTop: "22px",
    border: "1px solid var(--ds-border,rgb(196, 194, 194));",
    borderRadius: "4px",
    padding: "16px",
    backgroundColor: "var(--ds-surface-raised,rgb(255, 255, 255));",
  });

  return (
    <>
      <h4>Backups & Restore</h4>
      <Tabs onChange={(index) => console.log("Selected Tab", index + 1)} id="default">
        <TabList>
          <Tab>Backups</Tab>
          <Tab>Create Backup</Tab>
          <Tab>Restore from file</Tab>
          <Tab>API</Tab>
        </TabList>
        <TabPanel>
          <Box xcss={boxStyle}>
            <ListAllFlowsWithBackup />
          </Box>
        </TabPanel>
        <TabPanel>
          <Box xcss={boxStyle}>
            <Label>Select integration to backup</Label>
            <FlowSelectList callback={setFlowId} />
            <p></p>
            <BackupFlowButton flowId={flowId} />
          </Box>
        </TabPanel>

        <TabPanel>
          <Box xcss={boxStyle}>
            <RestoreFlowFromFile />
          </Box>
        </TabPanel>
        <TabPanel>
          <Box xcss={boxStyle}>
            <RestoreFlowAPI />
          </Box>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default BackupPage;
